import PalletSummary from "../components/PalletSummary";

export default function PalletSummaryPage() {
  return <PalletSummary />;
}
